<script setup lang="ts">
import $ from 'jquery';
import store from 'store';
import { onMounted } from 'vue';

import type { MenuPanel } from './globals';
import { __MENU_PANELS_COMPACT_MODE__ } from './globals';
import MenuSingleItem from './menu-single-item.vue';
import MenuSinglePanel from './menu-single-panel.vue';
import UserMenuPanel from './user-menu-panel.vue';
import { DummyUserPanel, useGlobalSeacrh, useLayoutManagement } from './util';

function showPanelAsDropDown(panel: MenuPanel) {
    if(__MENU_PANELS_COMPACT_MODE__ !== 'true') return true;
    return panel.panel.length > 1;
}

const { showCompactInterface } = useLayoutManagement();
const { userPanel, filteredPanels } = useGlobalSeacrh();

function updateCollapsed() {
    try {
        if(store.enabled) {
            let panels = store.get('menu-panels-toggle');
            if(!panels || (typeof (panels) != 'object')) {
                panels = {};
            }
            $('#menu-panels').find('.collapse').each(function() {
                const panel = $(this);
                panels[panel.attr('id') ?? ''] = panel.is('.in');
            });
            store.set('menu-panels-toggle', panels);
        }
    } catch(_err) { /**/ }
}

onMounted(() => {
    $(() => {
        try {
            if(store.enabled) {
                const panels = store.get('menu-panels-toggle');
                if(panels && (typeof (panels) == 'object')) {
                    for(const id in panels) {
                        $(`#${id}`).toggleClass('in', !!panels[id]);
                    }
                }
            }
        } catch(_err) { /**/ }
    });
});
</script>

<template>
    <template v-for="panel in filteredPanels" :key="panel.id">
        <template v-if="panel.name == 'Utente'">
            <UserMenuPanel v-if="!showCompactInterface" :panel="panel" />
        </template>
        <MenuSinglePanel
            v-else-if="showPanelAsDropDown(panel)"
            :panel="panel"
            :multiline-layout="panel.name === 'Menu fatture'"
            @collapse="updateCollapsed"
        />
        <MenuSingleItem v-else :form="panel.panel[0]!" />
    </template>
    <UserMenuPanel v-if="!showCompactInterface && !userPanel" :panel="DummyUserPanel" />
</template>
